<template>
  <div v-loading="!isLoaded">
    <tf-table
      v-if="isLoaded"
      v-test:table="'broker team'"
      v-bind="{
        parentalControls: true,
        findIndexBy: 'user_id',
        tableData: brokerTeam,
        tableMeta,
      }"
      @changeSortCriteria="$emit('changeSortCriteria', $event)"
    >
      <template #title>
        Broker team
      </template>
      <tf-button
        v-if="brokerTeam.length"
        slot="ctaHeader"
        v-test:button="'add member'"
        type="primary"
        icon="plus"
        size="text-icon"
        @click="$emit('clickAddTeamMember')"
      >
        Add team member
      </tf-button>
      <template
        v-if="actionError === 'get broker users'"
        #error
      >
        There was an error getting your broker team members.
        <tf-button
          size="text"
          tag="a"
          type="decline"
          no-branding
          @click="loadBrokerTeam(clientId)"
        >
          Reload the Broker Team
        </tf-button>
        or
        <tf-cta-email-support type="decline" />.
      </template>
      <broker-team-table-row
        :key="rowData.id"
        slot="parentRow"
        slot-scope="{ rowData }"
        :client-id="clientId"
        :contact="rowData"
        @clickAddTeamMember="$emit('clickAddTeamMember')"
      />
    </tf-table>
  </div>
</template>

<script>
  // vuex
  import { mapActions, mapState } from 'vuex';
  // components
  import BrokerTeamTableRow from '@/components/BrokerTeamTableRow';

  /**
   * The BrokerTeam table displays all broker users that have been assigned as a contact for a specific Client Record.
   *
   * @vuedoc
   * @exports TableBrokerTeam
   * @category Components
   */

  export default {
    name: 'TableBrokerTeam',
    components: { BrokerTeamTableRow },
    props: {
      /**
       * The ID of the employer used to interact with the API.
       */
      clientId: {
        type: [String, Number],
        required: true,
      },
      /**
       * The sort direction from the parent to be used in the child table component.
       */
      sortDirection: {
        type: String,
        default: 'asc',
      },
      /**
       * The sort property from the parent to be used in the child table component.
       */
      sortProp: {
        type: String,
        default: 'full_name',
      },
    },
    computed: {
      ...mapState('employerBrokerTeam', ['isLoaded', 'brokerTeam', 'actionError']),
      /**
       * Return an object to pass to the 'tableMeta' tf-table. The sort parameters are computed based on the instance props.
       *
       * @returns {object}
       */
      tableMeta() {
        return {
          columns: [
            {
              label: 'Name',
              prop: 'full_name',
              sortable: true,
            },
          ],
          sort: {
            direction: this.sortDirection,
            prop: this.sortProp,
          },
        };
      },
    },
    created() {
      if (this.isLoaded) {
        return;
      }

      this.loadBrokerTeam(this.clientId);
    },
    beforeDestroy() {
      this.resetBrokerTeam();
    },
    methods: {
      ...mapActions('employerBrokerTeam', ['loadBrokerTeam', 'resetBrokerTeam']),
    },
  };
</script>
